import React from 'react'
import { useQueryClient } from 'react-query'
import { toast } from 'react-toastify'
import { useToggleHighRisk } from 'api/hooks/use-municipality-permission-override'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'

const HighRiskToggle = ({ permission }) => {
  const queryClient = useQueryClient()

  const { mutate: toggleHighRisk, isLoading } = useToggleHighRisk({
    options: {
      onSuccess: (data) => {
        queryClient.invalidateQueries(['permissions', permission.id])
        queryClient.invalidateQueries(['permissions'])
        queryClient.invalidateQueries('sod_counts')
        queryClient.invalidateQueries('role_sod_counts')
        queryClient.invalidateQueries('employee_sod_counts')
        toast.success(data.message || 'High risk status updated')
      },
      onError: (error) => {
        console.error('Error toggling high risk:', error)
        toast.error('Failed to update high risk status. Please try again.')
      }
    }
  })

  const handleToggle = () => {
    if (isLoading) return

    const newValue = !permission.is_high_risk

    toggleHighRisk({
      municipalityPermissionId: permission.municipality_permission_id,
      isHighRisk: newValue
    })
  }

  return (
    <div>
      <div className="fw-bold mb-2">High Risk Status</div>
      <div className="form-check form-switch">
        <input
          className="form-check-input"
          type="checkbox"
          id="high-risk-toggle"
          checked={permission.is_high_risk}
          onChange={handleToggle}
          disabled={isLoading}
        />
        <label className="form-check-label" htmlFor="high-risk-toggle">
          {permission.is_high_risk ? 'High Risk' : 'Not High Risk'}
          {isLoading && (
            <FontAwesomeIcon icon={faSpinner} spin className="ms-2" size="sm" />
          )}
        </label>
      </div>
    </div>
  )
}

export default HighRiskToggle
